// EmailRecovery page
import React, { Component } from "react";
import { recoverEmail } from "../../../firebase/userManagement";
import styles from "./EmailRecovery.module.css";
import PropTypes from "prop-types";
import Layout from "../../../components/Layout";

class EmailRecovery extends Component {
    constructor(props) {
        super(props);

        this.state = {
            verified: "loading"
        };

        this.onLogoClick = this.onLogoClick.bind(this);
        this.renderState = this.renderState.bind(this);
    }

    static propTypes = {
        oobCode: PropTypes.string.isRequired
    };

    static defaultProps = {
        oobCode: "abc123"
    };

    componentDidMount() {
        const { oobCode } = this.props;
        recoverEmail(oobCode).then(verified => {
            this.setState({
                verified
            });
        });
    }

    onLogoClick = () => {
        this.props.history.push("/");
    };

    renderState = () => {
        const { verified } = this.state;
        let message = "";
        switch (verified) {
            case "success":
                message = "Your email settings have been reset!";
                break;
            case "loading":
                message = "Loading...";
                break;
            default:
                message = "An error occured, please try again.";
        }
        return <h1 className={styles.text}>{message}</h1>;
    };

    render() {
        return (
            <Layout title={"AXLRY - Recover Email"}>
                <div className={`${styles.page} center-container`}>
                    {this.renderState()}
                </div>
            </Layout>
        );
    }
}

export default EmailRecovery;
